// extracted by mini-css-extract-plugin
export default {"wrapper":"ManageGroupArtistsPopupFormStep_wrapper__YjhP0"};